const Getlocation = async (type = 'full') => {
    try {
        // Check if geolocation is supported by the browser
        if (!navigator.geolocation) {
            throw new Error('Geolocation is not supported by your browser');
        }

        // Get current position
        const position = await new Promise((resolve, reject) => {
            navigator.geolocation.getCurrentPosition(resolve, reject);
        });

        const { latitude, longitude } = position.coords;

        // If only coordinates are requested
        if (type === 'coordinates') {
            return {
                latitude,
                longitude
            };
        }

        // Get full address details using reverse geocoding
        const response = await fetch(
            `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}`
        );
        const data = await response.json();

        // Return full address details
        return {
            latitude,
            longitude,
            address: data.display_name,
            city: data.address.city || data.address.town || data.address.village,
            state: data.address.state,
            country: data.address.country,
            postalCode: data.address.postcode
        };
    } catch (error) {
        console.error('Error getting location:', error);
        throw error;
    }
};

export default Getlocation;
